import { getAllEquipmentsByParkId, updateEquipmentById } from "../store/collections/equipmentWorker"

export const equipmentManagerReloadAllEquipments = async (estacionamentoId) => {
    const items = await getAllEquipmentsByParkId({ estacionamentoId: estacionamentoId })
    for (const item of items) {
        item.command = "reload"
        await updateEquipmentById({ id: item.id, data: item })
    }
}
